<template>
	<!-- Vue Material Datapicker -->
	<!-- https://vuematerial.io/components/datepicker/ -->
	<md-datepicker
		ref="datepicker"
		:md-disabled-dates="disabledDates"
		:md-immediately="closeOnSelect"
		:value="value"
		@input="$emit('input', $event)"
		@md-opened="$emit('open')"
		@md-closed="$emit('close')"
		@md-clear="clear"
	>
		<label>{{ label }}</label>
	</md-datepicker>
</template>

<script>
export default {
	name: "Datepicker",
	props: {
		closeOnSelect: {
			type: Boolean,
			default: false,
			required: false
		},
		disabledDates: {
			type: [Function, Array],
			default: () => false,
			required: false
		},
		label: {
			type: String,
			required: true
		},
		value: {
			required: true,
			validator: (prop) => prop instanceof Date || prop === null // custom validator since null is not a valid type
		}
	},
	mounted() {
		this.$refs.datepicker.$refs.input.$el.setAttribute("readonly", "readonly");
	},
	methods: {
		clear() {
			this.$emit("input", null);
		},
		focus() {
			// method used by src/js/main2/components/media/ShareDialog.vue
			this.$el.querySelector("input").focus();
		}
	}
};
</script>

<style lang="scss" scoped>
	.md-datepicker /deep/ i:after {
		background-color: transparent !important;
	}
</style>
